import { render, staticRenderFns } from "./z_ueditor.vue?vue&type=template&id=e994c038&scoped=true"
import script from "./z_ueditor.vue?vue&type=script&lang=js"
export * from "./z_ueditor.vue?vue&type=script&lang=js"
import style0 from "./z_ueditor.vue?vue&type=style&index=0&id=e994c038&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e994c038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/cyimu/Desktop/shiliang/vgo/VGO_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e994c038')) {
      api.createRecord('e994c038', component.options)
    } else {
      api.reload('e994c038', component.options)
    }
    module.hot.accept("./z_ueditor.vue?vue&type=template&id=e994c038&scoped=true", function () {
      api.rerender('e994c038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobilePage/z_ueditor.vue"
export default component.exports